import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CtaSection = () => (
  <section className="bg-white pb-[70px] lg:pb-[110px]">
    <div className="max-w-[1240px] mx-auto px-5 lg:px-8">
      <div className="relative overflow-hidden rounded-3xl lg:rounded-[32px] px-6 py-11 lg:px-16 lg:py-[70px] flex flex-col lg:flex-row lg:items-center lg:justify-between gap-7 text-white">
        <img src="/img/login-envios.webp" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover object-[70%_center]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#15378A]/[0.97] via-[#1E429F]/80 to-[#1E429F]/15" />
        <div className="relative">
          <h2 className="text-[30px] lg:text-[42px] font-black leading-tight tracking-tight max-w-[560px]">Venda mais com <span className="text-[#FFD43B]">frete barato</span></h2>
          <p className="mt-3 text-base lg:text-lg text-white/90">Cadastre-se grátis e emita seu primeiro frete hoje.</p>
        </div>
        <Link to="/cadastro" className="relative inline-flex justify-center items-center gap-2 bg-[#F77820] hover:bg-[#e86a12] text-white font-extrabold rounded-full px-8 lg:px-10 py-4 lg:py-5 text-base lg:text-[19px] shadow-[0_10px_24px_rgba(247,120,32,0.35)] whitespace-nowrap">
          Criar conta grátis <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  </section>
);

export default CtaSection;
